// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contPingModal{
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
}
.titlePinglModal{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20%;
}
.lineTitlePing{
    width: 90%;
    position: absolute;
    left: 5%;
    top: 72%;
    color: #505050a3;
    height: 1px;
    background: #3b3b3ba3;
}
.contAnimationPingModal{
    position: relative;
    width: 100%;
    height: 50%;
    justify-content: center;
    align-items: center;
    display: flex;

}
.contActionsPingModal{
    position: relative;
    width: 100%;
    height: 30%;
    justify-content: center;
    align-items: center;
}
.constImg{
    position: relative;
    width: 25%;
    height: 80%;
    display: block;
}
.contAnimation{
    position: relative;
width: 35%;
height: 80%;
display: flex;
justify-content: center;
align-items: center;
}
.divImgPing{
    position: relative;
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.divtextPing{
    position: relative;
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: center;
    align-items: center;  
    color: #d5d5d5;
}
.icon-ping{
    width: 30%;
}
.msgPing{
    color: #34db42;
    font-size: medium;
}
.msgErrorPing{
    color: #db3434;
    font-size: medium;
}
/**********************Animation*****************************/
.dots-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
  }
  
  .dot {
    height: 10px;
    width: 20px;
    margin-right: 20px;
    border-radius: 50%;
    background-color: #bbfcb3;
    animation: pulse 1.5s infinite ease-in-out;
  }
  
  .dot:last-child {
    margin-right: 0;
  }
  
  .dot:nth-child(1) {
    animation-delay: -0.3s;
  }
  
  .dot:nth-child(2) {
    animation-delay: -0.1s;
  }
  
  .dot:nth-child(3) {
    animation-delay: 0.1s;
  }
  
  @keyframes pulse {
    0% {
      transform: scale(0.8);
      background-color: #b3fcb3;
      box-shadow: 0 0 0 0 rgba(184, 252, 178, 0.7);
    }
    25% {
        transform: scale(0.8);
        background-color: #96d39e;
        box-shadow: 0 0 0 0 rgba(152, 201, 142, 0.7);
      }
    50% {
      transform: scale(1.2);
      background-color: #6cfb67;
      box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);
    }
    75% {
        transform: scale(0.8);
        background-color: #96d39e;
        box-shadow: 0 0 0 0 rgba(152, 201, 142, 0.7);
      }
    100% {
      transform: scale(0.8);
      background-color: #b3fcbd;
      box-shadow: 0 0 0 0 rgba(190, 252, 178, 0.7);
    }
  }

  /***************************/
  .loading-wave {
    width: 100%;
height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  
  .loading-bar {
    width: 5px;
    height: 10px;
    margin: 10px;
    background-color: #34db42;
    border-radius: 2px;
    animation: loading-wave-animation 1s ease-in-out infinite;
  }
  
  .loading-bar:nth-child(2) {
    animation-delay: 0.1s;
  }
  
  .loading-bar:nth-child(3) {
    animation-delay: 0.2s;
  }
  
  .loading-bar:nth-child(4) {
    animation-delay: 0.3s;
  }
  
  @keyframes loading-wave-animation {
    0% {
      height: 10px;
    }
    25% {
        height: 15px;
      }
    
    50% {
      height: 30px;
    }
    75% {
        height: 15px;
      }
    100% {
      height: 10px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/styles/PingModal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;;AAEjB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB,UAAU;AACV,WAAW;AACX,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA,6DAA6D;AAC7D;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,0CAA0C;EAC5C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,qBAAqB;MACrB,yBAAyB;MACzB,4CAA4C;IAC9C;IACA;QACI,qBAAqB;QACrB,yBAAyB;QACzB,4CAA4C;MAC9C;IACF;MACE,qBAAqB;MACrB,yBAAyB;MACzB,6CAA6C;IAC/C;IACA;QACI,qBAAqB;QACrB,yBAAyB;QACzB,4CAA4C;MAC9C;IACF;MACE,qBAAqB;MACrB,yBAAyB;MACzB,4CAA4C;IAC9C;EACF;;EAEA,4BAA4B;EAC5B;IACE,WAAW;AACf,YAAY;IACR,aAAa;IACb,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yDAAyD;EAC3D;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,YAAY;IACd;IACA;QACI,YAAY;MACd;;IAEF;MACE,YAAY;IACd;IACA;QACI,YAAY;MACd;IACF;MACE,YAAY;IACd;EACF","sourcesContent":[".contPingModal{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\n.titlePinglModal{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 20%;\r\n}\r\n.lineTitlePing{\r\n    width: 90%;\r\n    position: absolute;\r\n    left: 5%;\r\n    top: 72%;\r\n    color: #505050a3;\r\n    height: 1px;\r\n    background: #3b3b3ba3;\r\n}\r\n.contAnimationPingModal{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 50%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    display: flex;\r\n\r\n}\r\n.contActionsPingModal{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 30%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.constImg{\r\n    position: relative;\r\n    width: 25%;\r\n    height: 80%;\r\n    display: block;\r\n}\r\n.contAnimation{\r\n    position: relative;\r\nwidth: 35%;\r\nheight: 80%;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\n}\r\n.divImgPing{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 80%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.divtextPing{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 20%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;  \r\n    color: #d5d5d5;\r\n}\r\n.icon-ping{\r\n    width: 30%;\r\n}\r\n.msgPing{\r\n    color: #34db42;\r\n    font-size: medium;\r\n}\r\n.msgErrorPing{\r\n    color: #db3434;\r\n    font-size: medium;\r\n}\r\n/**********************Animation*****************************/\r\n.dots-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n  \r\n  .dot {\r\n    height: 10px;\r\n    width: 20px;\r\n    margin-right: 20px;\r\n    border-radius: 50%;\r\n    background-color: #bbfcb3;\r\n    animation: pulse 1.5s infinite ease-in-out;\r\n  }\r\n  \r\n  .dot:last-child {\r\n    margin-right: 0;\r\n  }\r\n  \r\n  .dot:nth-child(1) {\r\n    animation-delay: -0.3s;\r\n  }\r\n  \r\n  .dot:nth-child(2) {\r\n    animation-delay: -0.1s;\r\n  }\r\n  \r\n  .dot:nth-child(3) {\r\n    animation-delay: 0.1s;\r\n  }\r\n  \r\n  @keyframes pulse {\r\n    0% {\r\n      transform: scale(0.8);\r\n      background-color: #b3fcb3;\r\n      box-shadow: 0 0 0 0 rgba(184, 252, 178, 0.7);\r\n    }\r\n    25% {\r\n        transform: scale(0.8);\r\n        background-color: #96d39e;\r\n        box-shadow: 0 0 0 0 rgba(152, 201, 142, 0.7);\r\n      }\r\n    50% {\r\n      transform: scale(1.2);\r\n      background-color: #6cfb67;\r\n      box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);\r\n    }\r\n    75% {\r\n        transform: scale(0.8);\r\n        background-color: #96d39e;\r\n        box-shadow: 0 0 0 0 rgba(152, 201, 142, 0.7);\r\n      }\r\n    100% {\r\n      transform: scale(0.8);\r\n      background-color: #b3fcbd;\r\n      box-shadow: 0 0 0 0 rgba(190, 252, 178, 0.7);\r\n    }\r\n  }\r\n\r\n  /***************************/\r\n  .loading-wave {\r\n    width: 100%;\r\nheight: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: flex-end;\r\n  }\r\n  \r\n  .loading-bar {\r\n    width: 5px;\r\n    height: 10px;\r\n    margin: 10px;\r\n    background-color: #34db42;\r\n    border-radius: 2px;\r\n    animation: loading-wave-animation 1s ease-in-out infinite;\r\n  }\r\n  \r\n  .loading-bar:nth-child(2) {\r\n    animation-delay: 0.1s;\r\n  }\r\n  \r\n  .loading-bar:nth-child(3) {\r\n    animation-delay: 0.2s;\r\n  }\r\n  \r\n  .loading-bar:nth-child(4) {\r\n    animation-delay: 0.3s;\r\n  }\r\n  \r\n  @keyframes loading-wave-animation {\r\n    0% {\r\n      height: 10px;\r\n    }\r\n    25% {\r\n        height: 15px;\r\n      }\r\n    \r\n    50% {\r\n      height: 30px;\r\n    }\r\n    75% {\r\n        height: 15px;\r\n      }\r\n    100% {\r\n      height: 10px;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
